// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['/util/etask.js', '/util/date.js', '/www/lum/pub/config.js',
    'lodash4'], (etask, date, config, _)=>
{

const E = {};

const recaptcha_conf = _.get(config, 'config.signup_recaptcha');
let lib_load_requested;
let load_ets = [];

window.recaptcha_onload = ()=>{
    let _load_ets = load_ets;
    load_ets = [];
    _load_ets.forEach(et=>et.return());
};

E.load = (opt = {})=>etask(function*(){
    this.on('uncaught', e=>console.log(e));
    if (!recaptcha_conf)
        return void this.return();
    if (!opt.no_wait)
        load_ets.push(this);
    if (lib_load_requested)
        return void (yield opt.no_wait ? this.return() : this.wait());
    lib_load_requested = true;
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?'
        +`render=${recaptcha_conf.site_key}&onload=recaptcha_onload`;
    script.async = true;
    script.defer = true;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
    yield opt.no_wait ? this.return() : this.wait();
});

E.unload = ()=>{
    if (!lib_load_requested)
        return;
    lib_load_requested = false;
    let badge = document.querySelector('.grecaptcha-badge');
    if (badge)
        document.body.removeChild(badge.parentNode);
    let script = document.querySelector("script[src='https://www.google.com"
        +`/recaptcha/api.js?render=${recaptcha_conf.site_key}`
        +"&onload=recaptcha_onload]'");
    if (script)
        script.remove();
};

E.new_token = action=>etask(function*(){
    this.on('uncaught', console.error);
    if (!recaptcha_conf)
        return void this.return();
    if (!(window.grecaptcha&&window.grecaptcha.execute))
    {
        // return nothing if recaptcha didn't load in 3 seconds to avoid
        // endless waiting for new token
        let et = E.load();
        let timeout = setTimeout(()=>et.return(), 3000);
        yield et;
        clearTimeout(timeout);
    }
    if (!(window.grecaptcha&&window.grecaptcha.execute))
        return void this.return();
    window.grecaptcha.execute(recaptcha_conf.site_key, {action})
        .then(token=>this.return(token));
    yield this.wait();
});

E.show_info = !recaptcha_conf && _.get(config, 'config.is_trusted_ip');

// keep interface synced with Brd_recaptcha from hubspot_lp.js
class Brd_recaptcha {
    new_token(){
        return new Promise(resolve=>{
            E.new_token('signup')
                .then(token=>resolve({type: 'recaptcha', token}));
        });
    }
}

// copy-paste start qhnwcx
class Brd_turnstile {
    constructor(conf){
        this.type = 'turnstile';
        this.conf = conf;
        this.loader = new Promise((resolve, reject)=>{
            let tid = setTimeout(()=>reject('turnstile load timeout'), 10000);
            window.onload_turnstile_cb = ()=>{
                clearTimeout(tid);
                resolve();
            };
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://challenges.cloudflare.com'
                +'/turnstile/v0/api.js'
                +'?render=explicit&onload=onload_turnstile_cb';
            script.async = true;
            script.defer = true;
            script.onerror = ()=>reject('turnstile load error');
            let s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(script, s);
        });
    }
    _get_target($form){
        let target = $form.querySelector('.hs_submit');
        if (!target)
            target = $form.querySelector('.signup');
        return target;
    }
    _set_error($cap, msg){
        let $err = $cap.parentNode.querySelector('.brd_cap_err');
        if (!msg)
        {
            if ($err)
                $err.remove();
            return;
        }
        if (!$err)
        {
            $err = document.createElement('div');
            $err.className = 'brd_cap_err';
            $err.style.color = '#E22541';
            $err.style.fontSize = '12px';
            $cap.parentNode.insertBefore($err, $cap.nextSibling);
        }
        $err.textContent = msg;
    }
    new_token($form){
        // $('form') returns complex jquery object when $ is query
        // $('form') returns single element when $ is browser built in
        $form = !($form instanceof HTMLFormElement) ? $form[0] : $form;
        let start = Date.now();
        let id = 'turnstile_container_'+Math.random().toString().substring(2);
        var $ts = document.createElement('div');
        $ts.setAttribute('id', id);
        let target = this._get_target($form);
        if (target)
            target.parentNode.insertBefore($ts, target);
        else
            document.body.appendChild($ts);
        let captcha_required = e=>{
            e.preventDefault();
            e.stopImmediatePropagation();
            this._set_error($ts, 'captcha is required');
        };
        let res = this.loader.then(()=>new Promise((resolve, reject)=>{
            let tid = setTimeout(()=>reject('turnstile token timeout'), 20000);
            window.turnstile.render('#'+id, {
                sitekey: this.conf.site_key,
                'before-interactive-callback': ()=>{
                    clearTimeout(tid);
                    $form.addEventListener('submit', captcha_required, true);
                },
                callback: token=>{
                    clearTimeout(tid);
                    resolve({type: this.type, token, time: Date.now()-start});
                },
            });
        }));
        res.finally(()=>{
            this._set_error($ts, null);
            $form.removeEventListener('submit', captcha_required, true);
        });
        return res;
    }
}

class Null_captcha {
    new_token(){
        return Promise.reject('null captcha');
    }
}
// copy-paste end qhnwcx

let captcha_provider;
function get_captcha_provider(){
    if (captcha_provider)
        return captcha_provider;
    let turnstile_conf = _.get(config, 'config.turnstile_conf');
    if (turnstile_conf)
        captcha_provider = Promise.resolve(new Brd_turnstile(turnstile_conf));
    else if (recaptcha_conf)
        captcha_provider = Promise.resolve(new Brd_recaptcha());
    else
        captcha_provider = Promise.resolve(new Null_captcha());
    return captcha_provider;
}

E.new_signup_token = _.throttle($form=>etask(function*(){
    get_captcha_provider().then(provider=>{
        provider.new_token($form).then(
            rec=>this.continue(rec),
            reason=>this.continue({type: 'error', reason}));
    });
    return yield this.wait();
}), 10*date.ms.SEC, {trailing: false});

return E; }); // eslint-disable-line
